/**
 * Every IANA zone this browser knows, deduped, with `priority` entries listed first in the order given
 * so a current value or "the zone I'm in" needs no scrolling. A falsy entry in `priority` (an unset
 * schedule zone, an enterprise that has not loaded yet) drops out rather than showing as a blank option.
 */
export function availableTimezones(...priority: Array<string | undefined>): string[] {
    const all = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : []
    return [...new Set([...priority, ...all].filter(Boolean))] as string[]
}
